{
  "id": "campaign-055",
  "name": "Golden Acre",
  "seed": "campaign:55",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".......RRRRR",
    ".......RRRRR",
    "......._____",
    "............",
    ".y.y.e..y.y.",
    ".....e......",
    "fffffff..fff",
    "............",
    "....y..y....",
    "............",
    "............",
    "f..fffffffff",
    "..cc....cc..",
    "..cc.x..cc..",
    "..cc....cc..",
    "....y..y....",
    "........#...",
    "x..........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 6,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 15
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 7
    },
    {
      "kind": "rabbit",
      "x": 0,
      "y": 15
    },
    {
      "kind": "rabbit",
      "x": 11,
      "y": 8
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 7,
      "y": 17
    },
    {
      "kind": "gas",
      "x": 6,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 17
    },
    {
      "kind": "repair",
      "x": 5,
      "y": 8
    }
  ],
  "generatorVersion": 3,
  "level": 55,
  "biome": "farm",
  "par": {
    "reel": 6150,
    "push": 5174,
    "selfPropelled": 4776,
    "tractor": 4760,
    "zeroTurn": 3570,
    "fairway": 2530
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 5,
      "zeroTurn": 12,
      "fairway": 19
    }
  }
}
